import styled from 'styled-components/macro';

const FormField = styled.div`
	margin-bottom: 16px;
`;

export default FormField;
